// Content contract for Smart Levo India Pvt Ltd
// Source: "Smart Levo Content" Google Doc provided by the client

export const companyInfo = {
  name: "Smart Levo India Pvt Ltd",
  tagline: "Authorised Dealer & Supplier of Canny Elevators | India's Trusted Multi-Brand Maintenance",
  phone: "+91 9867 798 994",
  phone2: "+91 7700 971 812",
  phoneRaw: "+919867798994",
  phone2Raw: "+917700971812",
  email: "info@smartlevo.com",
  email2: "care@smartlevo.com",
  address: "27, Ali Bilal Siddi CHSL, Alidada Estate, S.G. Barve Marg, Near Bus Depot, Kurla East, Mumbai, Maharashtra, India – 400024",
  rankBadge: "Canny Ranked #9 Elevator Brand Worldwide (2025)",
  dealerBadge: "Authorised Canny Elevator Dealer & Supplier in India",
  maintenanceBadge: "Professional Multi-Brand Elevator Maintenance"
};

export const heroStats = [
  { value: "20+", label: "Years Experience", testId: "stat-experience" },
  { value: "50+", label: "Projects Completed", testId: "stat-projects" },
  { value: "30+", label: "Elevators Maintained", testId: "stat-elevators" },
  { value: "24×7", label: "Service Support", testId: "stat-support" }
];

export const marqueeItems = [
  "Multi-Brand Elevator Maintenance",
  "Authorised Canny Elevator Dealer",
  "Annual Maintenance Contracts",
  "Elevator Modernization",
  "24×7 Breakdown Support",
  "Genuine Spare Parts"
];

export const aboutContent = {
  topLabel: "Elevator Maintenance & Service Expertise",
  heading: "Reliable Elevator Services for Every Building",
  description: "Smart Levo India provides professional elevator maintenance, AMC, repair and modernization services for residential, commercial and hospitality properties. Our multi-brand elevator expertise and experienced technical team help keep elevator systems safe, reliable and efficient.",
  pointersLeft: [
    { title: "Multi-Brand Elevator Maintenance", desc: "Professional maintenance for multiple elevator brands" },
    { title: "Elevator AMC Services", desc: "Planned maintenance for reliable performance" },
    { title: "Preventive Maintenance", desc: "Regular servicing to help prevent breakdowns" },
    { title: "Elevator Repair & Troubleshooting", desc: "Technical support for operational issues" }
  ],
  pointersRight: [
    { title: "Elevator Modernization & Upgrades", desc: "Modern solutions for ageing elevator systems" },
    { title: "24×7 Service Support", desc: "Responsive assistance for breakdown requirements" },
    { title: "Genuine Elevator Spare Parts", desc: "Quality parts for maintenance and repairs" },
    { title: "Experienced Technical Team", desc: "Skilled engineers, supervisors & technicians" }
  ],
  button: "Book an Elevator Maintenance Survey",
  overlayLabel: "Technical Service Expertise",
  overlayText: "Professional Elevator Maintenance & Support",
  highlightNumber: "24×7",
  highlightText: "Service Support"
};

export const projectsContent = {
  topLabel: "Featured Elevator Projects",
  heading: "Real Projects. Trusted Performance.",
  intro: "Explore a selection of Canny elevator projects supplied and installed by Smart Levo India Pvt Ltd, delivering reliable vertical transportation for residential, commercial, hospitality, sports and mixed-use developments across India."
};

export const projects = [
  {
    id: "k-raheja-voco-mumbai",
    badge: "Hospitality Project",
    title: "Hospitality Project — Mumbai",
    subtitle: "Premium Hospitality Vertical Transportation",
    description: "High-end hospitality project requiring dependable vertical transportation for guests, staff and service operations.",
    overview: "A high-end hospitality project requiring dependable vertical transportation for guests, staff and service operations. Smart Levo provided professional elevator support focused on smooth operation, safety, reliability and consistent performance in a demanding hotel environment.",
    specs: [
      "High-performance passenger elevator system",
      "VVVF variable-speed drive technology",
      "Automatic centre-opening doors",
      "Premium stainless-steel cabin finishes"
    ],
    capacity: "10 to 21 Persons (680 kg – 1,500 kg)",
    image: "/images/projects/k-raheja-voco-mumbai.jpeg"
  },
  {
    id: "fortune-group",
    badge: "Residential Project",
    title: "Residential Project — Mumbai",
    subtitle: "Reliable Vertical Transportation for Commercial Spaces",
    description: "A commercial project requiring dependable elevator performance for smooth and efficient movement of occupants and visitors.",
    overview: "A commercial project requiring dependable elevator performance for smooth and efficient movement of occupants and visitors. Smart Levo provided professional technical support with a focus on safe operation, reliable performance and minimizing service interruptions.",
    specs: [
      "High-efficiency passenger elevator system",
      "VVVF variable-frequency drive",
      "Automatic centre-opening doors",
      "Stainless-steel cabin with durable interior finishes"
    ],
    capacity: "8 to 20 Persons (544 kg – 1,360 kg)",
    image: "/images/projects/fortune-group.jpeg"
  },
  {
    id: "doubletree-hilton-varanasi",
    badge: "Hospitality Project",
    title: "Hospitality Project — Varanasi",
    subtitle: "Premium Hotel Vertical Transportation",
    description: "A hospitality project requiring dependable elevator solutions for seamless guest, staff and service movement across the property.",
    overview: "A hospitality project requiring dependable elevator solutions for seamless guest, staff and service movement across the property. Smart Levo supported the project with a focus on installation quality, safe operation, smooth performance and reliable vertical transportation.",
    specs: [
      "High-performance passenger elevator system",
      "VVVF variable-frequency drive technology",
      "Automatic centre-opening doors",
      "Durable stainless-steel cabin finishes"
    ],
    capacity: "8 to 20 Persons (544 kg – 1,360 kg)",
    image: "/images/projects/doubletree-hilton-varanasi.jpeg"
  },
  {
    id: "south-united-football-club",
    badge: "Sports Facility Project",
    title: "Sports Facility Project — Bangalore",
    subtitle: "Sports Facility Vertical Transportation",
    description: "A dedicated sports facility project requiring reliable vertical transportation for players, staff, visitors and day-to-day facility operations.",
    overview: "A dedicated sports facility project requiring reliable vertical transportation for players, staff, visitors and day-to-day facility operations. Smart Levo provided professional elevator support with emphasis on safe, smooth and dependable movement within the premises.",
    specs: [
      "High-efficiency passenger elevator system",
      "VVVF variable-frequency drive",
      "Automatic centre-opening doors",
      "Durable stainless-steel cabin finish"
    ],
    capacity: "8 to 15 Persons (544 kg – 1,020 kg)",
    image: "/images/projects/south-united-football.jpeg"
  },
  {
    id: "residential-tower-vikhroli",
    badge: "Residential Project",
    title: "Residential Project — Mumbai",
    subtitle: "Modern Residential Vertical Transportation",
    description: "A residential high-rise project requiring dependable elevator solutions for smooth daily movement of residents and visitors.",
    overview: "A residential high-rise project requiring dependable elevator solutions for smooth daily movement of residents and visitors. Smart Levo delivered professional elevator support focused on reliable performance, passenger comfort and long-term operational efficiency.",
    specs: [
      "High-efficiency passenger elevator system",
      "VVVF variable-frequency drive technology",
      "Automatic centre-opening doors",
      "Premium stainless-steel cabin with modern interior finishes"
    ],
    capacity: "8 to 18 Persons (544 kg – 1,225 kg)",
    image: "/images/projects/residential-tower-vikhroli.jpeg"
  },
  {
    id: "nidhi-residency",
    badge: "Residential Project",
    title: "Residential Project — Mumbai",
    subtitle: "Reliable Residential Vertical Transportation",
    description: "A residential development requiring dependable elevator service for the smooth and safe movement of residents and visitors.",
    overview: "A residential development requiring dependable elevator service for the smooth and safe movement of residents and visitors. Smart Levo supported the project with a focus on consistent elevator performance, passenger comfort and reliable day-to-day operation.",
    specs: [
      "Efficient passenger elevator system",
      "VVVF variable-frequency drive",
      "Automatic centre-opening doors",
      "Stainless-steel cabin with durable interior finishes"
    ],
    capacity: "6 to 13 Persons (408 kg – 884 kg)",
    image: "/images/projects/nidhi-residency.jpeg"
  }
];

export const servicesContent = {
  topLabel: "Comprehensive Elevator Services",
  heading: "Professional Elevator Services & Multi-Brand AMC",
  intro: "From elevator installation and preventive maintenance to AMC, repairs and modernization, Smart Levo India provides reliable vertical transportation solutions for residential, commercial, hospitality and industrial properties."
};

export const services = [
  {
    id: "multi-brand-maintenance",
    badge: "Multi-Brand Expert",
    title: "Multi-Brand Elevator Maintenance",
    description: "Professional maintenance and technical support for elevators across multiple brands.",
    icon: "Wrench"
  },
  {
    id: "elevator-installation",
    badge: "Turnkey Solutions",
    title: "Elevator Installation",
    description: "Professional elevator installation for new buildings, with solutions tailored to project and site requirements.",
    icon: "Building2"
  },
  {
    id: "preventive-maintenance",
    badge: "Preventive Care",
    title: "Preventive Elevator Maintenance",
    description: "Scheduled inspections, servicing and safety checks designed to maintain reliable elevator performance.",
    icon: "ShieldCheck"
  },
  {
    id: "amc-contracts",
    badge: "Flexible AMC Plans",
    title: "Annual Maintenance Contract (AMC)",
    description: "Comprehensive and non-comprehensive elevator AMC plans for residential, commercial, hospitality and industrial properties.",
    icon: "FileText"
  },
  {
    id: "elevator-modernization",
    badge: "System Upgrades",
    title: "Elevator Modernization",
    description: "Upgrade ageing elevator systems, controls and components to improve performance, reliability and efficiency.",
    icon: "RefreshCw"
  },
  {
    id: "breakdown-support",
    badge: "24×7 Support",
    title: "Elevator Breakdown Support",
    description: "Responsive technical assistance for elevator breakdowns, faults and urgent service requirements.",
    icon: "PhoneCall"
  },
  {
    id: "repair-replacement",
    badge: "Repair Services",
    title: "Elevator Repair & Replacement",
    description: "Repair and replacement of critical elevator components to restore safe and dependable operation.",
    icon: "Wrench"
  },
  {
    id: "spare-parts-support",
    badge: "Genuine Parts",
    title: "Elevator Spare Parts Support",
    description: "Genuine and compatible spare parts support for elevator maintenance, repair and replacement requirements.",
    icon: "Cpu"
  }
];

export const trustContent = {
  topLabel: "Why Industry Leaders Trust Smart Levo",
  heading: "Engineered for Absolute Safety & Uninterrupted Uptime",
  description: "Whether you're managing a high-rise commercial tower or a premium residential villa, Smart Levo India Pvt Ltd delivers reliable elevator maintenance and support with authorized Canny elevators, transparent AMC pricing, and full compliance with Indian safety standards.",
  cta: "Schedule Expert Site Visit"
};

export const faqs = [
  {
    question: "Do you provide maintenance for non-Canny elevator brands like Otis, KONE, and Schindler?",
    answer: "Yes. Smart Levo provides professional multi-brand elevator maintenance for elevators from various manufacturers, subject to site assessment and system requirements."
  },
  {
    question: "What is your emergency breakdown response time?",
    answer: "Our technical team provides 24×7 elevator breakdown support for urgent service requirements. Response times may vary depending on location, site conditions and the nature of the breakdown."
  },
  {
    question: "Are you an authorized dealer for Canny Elevators in India?",
    answer: "Yes. Smart Levo India Pvt Ltd is an authorised dealer and supplier of Canny Elevators in India, providing Canny elevator solutions along with professional installation and technical support."
  },
  {
    question: "What types of AMC packages do you offer?",
    answer: "Smart Levo offers Annual Maintenance Contract (AMC) options designed for different building and elevator requirements, including preventive maintenance, inspections, servicing and breakdown support."
  }
];

export const testimonialsContent = {
  topLabel: "Client Experience",
  heading: "Trusted Elevator Maintenance & Service Experiences",
  intro: "Hear from facility teams, property managers and businesses who rely on Smart Levo for professional elevator maintenance, AMC, repair and technical support."
};

export const testimonials = [
  {
    id: "1",
    rating: 5,
    comment: "The Smart Levo team has been professional and responsive with our elevator service requirements. Their technical support and maintenance approach have helped ensure smooth and reliable elevator operation for our property.",
    role: "Facility Management Representative",
    propertyType: "Hospitality Property",
    location: "Mumbai"
  },
  {
    id: "2",
    rating: 5,
    comment: "We have had a good experience with Smart Levo for our elevator maintenance requirements. The team is technically capable, responsive when support is needed, and takes a practical approach to keeping the elevator system running reliably.",
    role: "Property Management Representative",
    propertyType: "Commercial Property",
    location: "Mumbai"
  },
  {
    id: "3",
    rating: 5,
    comment: "Smart Levo has been dependable in handling our elevator service requirements. Their team understands the importance of smooth elevator operation in a hospitality environment and provides prompt technical support whenever required.",
    role: "Hotel Operations Representative",
    propertyType: "Hospitality Property",
    location: "Varanasi"
  },
  {
    id: "4",
    rating: 5,
    comment: "The Smart Levo team has been professional and easy to coordinate with for our elevator service requirements. Their maintenance support and technical assistance have helped us maintain dependable elevator performance at the facility.",
    role: "Facility Management Representative",
    propertyType: "Sports Facility",
    location: "Bangalore"
  }
];

export const ctaContent = {
  topLabel: "Get Started Today",
  heading: "Need Reliable Elevator Maintenance?",
  description: "Partner with Smart Levo India for professional multi-brand elevator maintenance, AMC, repairs and 24×7 service support. As an authorised Canny elevator dealer in India, we deliver reliable elevator solutions for residential, commercial and hospitality properties."
};

export const footerContent = {
  brandName: "SMART LEVO INDIA",
  tagline: "Authorised Supplier of Canny Elevators",
  description: "Smart Levo India Pvt Ltd is the authorised dealer and supplier of Canny elevators along with multi-brand maintenance services. We deliver safe, reliable and efficient vertical transportation solutions for residential, commercial, hospitality and institutional properties.",
  quickLinks: [
    { label: "About Company", href: "#about" },
    { label: "Projects", href: "#projects" },
    { label: "Services", href: "#services" },
    { label: "Why Choose Us", href: "#trust" },
    { label: "Testimonials", href: "#testimonials" }
  ],
  projectLinks: [
    "K Raheja Voco, Mumbai",
    "Fortune Group, Mumbai",
    "DoubleTree by Hilton, Varanasi",
    "South United FC, Bangalore",
    "Residential Tower, Vikhroli",
    "Nidhi Residency, Mumbai"
  ],
  copyright: "© 2026 Smart Levo India Pvt Ltd. All rights reserved. Authorised Canny Elevator Supplier & Maintenance Specialist."
};

export const privacyPolicy = {
  title: "Privacy Policy",
  effectiveDate: "01-04-2026",
  intro: [
    "At Smart Levo India Pvt Ltd (“Smart Levo India”, “we”, “our”, or “us”), we respect your privacy and are committed to protecting the personal information shared with us through our website.",
    "This Privacy Policy explains how we collect, use, store, and protect information when you visit or use our website, request a quotation, schedule a consultation, submit an enquiry, or contact us regarding our elevator products and services."
  ],
  sections: [
    {
      heading: "1. Information Collected Through Contact Forms",
      blocks: [
        { p: "When you submit a contact form, quotation request, consultation request, or service enquiry on our website, we may collect:" },
        { list: ["Name", "Company or organisation name", "Email address", "Phone number", "WhatsApp number", "Project or site location", "Elevator requirements", "Service requirements", "Message or enquiry details", "Any other information voluntarily submitted through the form"] },
        { p: "We collect this information to:" },
        { list: ["Respond to your enquiry", "Understand your elevator or maintenance requirements", "Provide quotations", "Schedule consultations or site visits", "Contact you regarding installation, repair, maintenance, AMC, modernization, or other services", "Provide customer support"] },
        { p: "The information submitted through the contact form may be delivered to our official email address, CRM system, or other authorised communication platform used by Smart Levo India." }
      ]
    },
    {
      heading: "2. WhatsApp Communication",
      blocks: [
        { p: "Our website may include a WhatsApp button that allows visitors to contact Smart Levo India Pvt Ltd through WhatsApp." },
        { p: "When you click the WhatsApp button and initiate a conversation:" },
        { list: ["You may be redirected to WhatsApp or WhatsApp Web.", "Your WhatsApp phone number and the information you choose to send may become visible to us.", "We may receive and retain the contents of your messages, documents, images, or other information that you voluntarily share.", "We may use this information to respond to your enquiry, provide quotations, arrange site visits, or deliver customer support.", "We may contact you through WhatsApp regarding your enquiry or requested services."] },
        { p: "Your use of WhatsApp is also subject to WhatsApp’s own Terms of Service and Privacy Policy. WhatsApp is a third-party communication platform, and its data practices are governed by its own policies." },
        { p: "We recommend that you do not send sensitive personal information, passwords, financial information, or unnecessary confidential documents through WhatsApp." }
      ]
    },
    {
      heading: "3. Contact Form and WhatsApp Data Sharing",
      blocks: [
        { p: "Information submitted through our contact form or shared with us through WhatsApp may be accessed by authorised employees, representatives, service providers, or contractors who need the information to respond to your enquiry or provide our services." },
        { p: "We do not sell or rent your personal information. Information may be shared with service providers such as:" },
        { list: ["Website hosting providers", "Email service providers", "CRM platforms", "WhatsApp or communication service providers", "IT and technical service providers", "Professional advisers", "Government authorities where legally required"] },
        { p: "We share only information that is reasonably necessary for the relevant business or service purpose." }
      ]
    },
    {
      heading: "4. Cookies and Website Technologies",
      blocks: [
        { p: "Our website may use cookies or similar technologies to:" },
        { list: ["Ensure proper website functionality", "Remember preferences", "Improve website performance", "Understand visitor behaviour", "Measure website traffic", "Improve marketing and advertising performance"] },
        { p: "You can manage or disable cookies through your browser settings. However, disabling certain cookies may affect some website functionality." },
        { p: "If the website uses third-party analytics or advertising tools, such as Google Analytics, Google Ads, or Meta Pixel, those services may collect information according to their own privacy policies." }
      ]
    },
    {
      heading: "5. Sharing of Information",
      blocks: [
        { p: "We do not sell, rent, or commercially trade your personal information." },
        { p: "We may share information with trusted third parties where necessary to operate our business or provide services, including:" },
        { list: ["Website hosting providers", "Email service providers", "CRM platforms", "Communication and messaging providers", "Analytics providers", "IT and technical service providers", "Professional advisers", "Government authorities or law-enforcement agencies where legally required"] },
        { p: "Such information will be shared only where reasonably necessary for the relevant purpose or where required by law." }
      ]
    },
    {
      heading: "6. Data Security",
      blocks: [
        { p: "We take reasonable technical and organisational measures to protect your personal information against:" },
        { list: ["Unauthorised access", "Misuse", "Loss", "Alteration", "Disclosure", "Destruction"] },
        { p: "However, no method of online transmission or electronic storage is completely secure. Therefore, we cannot guarantee absolute security of information transmitted through the internet." }
      ]
    },
    {
      heading: "7. Data Retention",
      blocks: [
        { p: "We retain personal information only for as long as reasonably necessary to:" },
        { list: ["Respond to enquiries", "Provide services", "Maintain business records", "Complete ongoing projects", "Resolve disputes", "Comply with legal and regulatory obligations", "Protect our legitimate business interests"] },
        { p: "When information is no longer required, we may delete, anonymise, or securely dispose of it, subject to applicable legal requirements." }
      ]
    },
    {
      heading: "8. Third-Party Links",
      blocks: [
        { p: "Our website may contain links to third-party websites, platforms, or services." },
        { p: "We are not responsible for the privacy practices, content, or security of third-party websites. We recommend reviewing the privacy policies of those websites before providing personal information." }
      ]
    },
    {
      heading: "9. Marketing Communications",
      blocks: [
        { p: "By submitting an enquiry or voluntarily contacting us through WhatsApp, phone, or email, you agree that we may contact you regarding your enquiry, requested quotation, consultation, project, installation, maintenance, repair, or related services." },
        { p: "Where legally permitted, we may also send information about relevant products or services. You may request that we stop sending promotional communications at any time." }
      ]
    },
    {
      heading: "10. Your Privacy Rights",
      blocks: [
        { p: "Depending on applicable law, you may have the right to:" },
        { list: ["Request access to personal information held about you", "Request correction of inaccurate information", "Request deletion of your information", "Withdraw consent where processing is based on consent", "Request information about how your data is being used", "Object to certain uses of your information"] },
        { p: "To exercise these rights, please contact us using the details below. We may need to verify your identity before processing your request." },
        { p: "India’s Digital Personal Data Protection framework recognises principles such as lawful processing, purpose limitation, data minimisation, accuracy, security, and accountability. The exact obligations applicable to an organisation may depend on the nature of its processing activities and the applicable implementation requirements." }
      ]
    },
    {
      heading: "11. Children’s Privacy",
      blocks: [
        { p: "Our website and services are intended for businesses, property owners, organisations, and other adults. We do not knowingly collect personal information from children. If you believe that a child has submitted personal information to us, please contact us so that appropriate action can be taken." }
      ]
    },
    {
      heading: "12. Changes to This Privacy Policy",
      blocks: [
        { p: "We may update this Privacy Policy from time to time to reflect changes in our services, technology, or legal requirements." },
        { p: "Any updated version will be published on this page with a revised effective date." }
      ]
    },
    {
      heading: "13. Contact Us",
      blocks: [
        { p: "If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us:" },
        { list: ["Company: Smart Levo India Pvt Ltd", "Website: smartlevo.com", "Email: info@smartlevo.com", "Phone: +91 9867 798 994 / +91 7700 971 812", "Address: 27, Ali Bilal Siddi CHSL, Alidada Estate, S.G. Barve Marg, Near Bus Depot, Kurla East, Mumbai, Maharashtra, India - 400024."] }
      ]
    }
  ]
};

export const termsOfService = {
  title: "Terms of Service",
  effectiveDate: "01-04-2026",
  intro: [
    "Welcome to Smart Levo India Pvt Ltd (“Smart Levo India”, “we”, “our”, or “us”).",
    "These Terms & Conditions govern your access to and use of our website and the information, products, and services made available through it.",
    "By accessing or using the website, you agree to comply with these Terms & Conditions. If you do not agree with any part of these terms, please do not use the website."
  ],
  sections: [
    {
      heading: "1. About Our Services",
      blocks: [
        { p: "Smart Levo India provides elevator-related products and services, which may include:" },
        { list: ["Canny elevator sales and supply", "Elevator installation", "Multi-brand elevator maintenance", "Preventive maintenance", "Annual Maintenance Contracts", "Elevator repair and replacement", "Emergency breakdown support", "Elevator modernization", "Spare parts support", "Technical consultation", "Site visits and project assessments"] },
        { p: "The availability and scope of any product or service may vary depending on the project, site requirements, location, technical feasibility, and applicable agreement." }
      ]
    },
    {
      heading: "2. Website Information",
      blocks: [
        { p: "The information provided on this website is intended for general informational purposes." },
        { p: "Product specifications, images, descriptions, capacities, dimensions, features, availability, service coverage, and other details may be subject to change without prior notice." },
        { p: "The final specifications, pricing, scope of work, and delivery details will be confirmed through the applicable quotation, proposal, purchase order, or service agreement." }
      ]
    },
    {
      heading: "3. Enquiries and Quotations",
      blocks: [
        { p: "Submitting an enquiry or quotation request through the website does not automatically create a contract between you and Smart Levo India." },
        { p: "A quotation may include:" },
        { list: ["Product or service details", "Project scope", "Technical specifications", "Pricing", "Applicable taxes", "Installation charges", "Delivery timeline", "Payment schedule", "Warranty terms", "Maintenance terms", "Client responsibilities", "Other project-specific conditions"] },
        { p: "A contract or service engagement will be formed only after the relevant quotation or agreement is accepted and any required advance payment or documentation is completed." }
      ]
    },
    {
      heading: "4. Product and Service Availability",
      blocks: [
        { p: "All products and services are subject to:" },
        { list: ["Availability", "Technical feasibility", "Site conditions", "Location", "Required approvals", "Availability of parts and equipment", "Manufacturer or supplier conditions", "Applicable safety and regulatory requirements"] },
        { p: "We reserve the right to modify, replace, or discontinue any product or service without prior notice." }
      ]
    },
    {
      heading: "5. Site Inspection and Technical Assessment",
      blocks: [
        { p: "Certain elevator services may require a site inspection or technical assessment before a final quotation can be issued." },
        { p: "The final recommendation, design, equipment selection, installation method, and pricing may depend on factors such as:" },
        { list: ["Building structure", "Shaft dimensions", "Pit and overhead availability", "Electrical requirements", "Load and capacity requirements", "Travel height", "Usage conditions", "Safety requirements", "Local regulations", "Existing elevator condition"] },
        { p: "Any initial information provided through the website is indicative until confirmed through a technical assessment." }
      ]
    },
    {
      heading: "6. Client Responsibilities",
      blocks: [
        { p: "The client is responsible for providing accurate and complete information, documents, approvals, access, and cooperation required for the project." },
        { p: "The client may be required to provide:" },
        { list: ["Correct site details", "Building drawings and measurements", "Electrical connection and power availability", "Necessary permissions and approvals", "Safe site access", "Civil and structural work, where agreed", "Timely decisions and approvals", "Suitable working conditions", "Accurate contact and billing information"] },
        { p: "Delays caused by missing information, delayed approvals, restricted access, or site-related issues may affect the project timeline and cost." }
      ]
    },
    {
      heading: "7. Pricing and Payments",
      blocks: [
        { p: "Unless otherwise stated in writing:" },
        { list: ["Prices will be specified in the applicable quotation or proposal.", "Applicable taxes and government charges may be charged separately.", "Payment terms will be stated in the quotation, invoice, or service agreement.", "Work or delivery may be delayed or suspended if payments are not made on time.", "Additional work outside the agreed scope may attract additional charges.", "Transportation, civil work, electrical work, permissions, or other third-party costs may be charged separately where applicable."] },
        { p: "The payment, cancellation, refund, warranty, and maintenance terms agreed in the relevant quotation or service agreement will prevail over general website information." }
      ]
    },
    {
      heading: "8. Installation and Maintenance",
      blocks: [
        { p: "Installation, repair, modernization, and maintenance services may be subject to:" },
        { list: ["Site readiness", "Equipment availability", "Technical inspection", "Safety requirements", "Manufacturer instructions", "Availability of spare parts", "Client cooperation", "Applicable laws and regulations"] },
        { p: "Maintenance and AMC services will be governed by the specific terms, exclusions, response times, visit schedules, and service coverage mentioned in the relevant AMC or service agreement." }
      ]
    },
    {
      heading: "9. Emergency Breakdown Support",
      blocks: [
        { p: "Any emergency response time displayed on the website is an indicative service commitment and may vary depending on:" },
        { list: ["Customer location", "Traffic and travel conditions", "Technician availability", "Nature of the breakdown", "Availability of spare parts", "Site access", "Safety conditions", "Force majeure events"] },
        { p: "Emergency support does not necessarily mean that repairs will be completed immediately. Some issues may require additional inspection, parts, approvals, or follow-up visits." }
      ]
    },
    {
      heading: "10. Warranty",
      blocks: [
        { p: "Warranty coverage, duration, exclusions, and conditions will be governed by the applicable manufacturer warranty, quotation, invoice, or service agreement." },
        { p: "Warranty may not cover issues caused by:" },
        { list: ["Misuse", "Negligence", "Unauthorised modifications", "Improper operation", "External damage", "Electrical fluctuations", "Water or fire damage", "Failure to follow maintenance instructions", "Repairs performed by unauthorised persons", "Normal wear and tear", "Circumstances outside the agreed warranty terms"] },
        { p: "The specific warranty terms provided with the product or service will apply." }
      ]
    },
    {
      heading: "11. Intellectual Property",
      blocks: [
        { p: "All content on the website, including:" },
        { list: ["Text", "Logos", "Graphics", "Images", "Icons", "Designs", "Layouts", "Videos", "Trademarks", "Software", "Branding materials"] },
        { p: "is owned by or licensed to Smart Levo India or the respective rights holder, unless otherwise stated." },
        { p: "You may not copy, reproduce, modify, distribute, publish, or commercially use website content without prior written permission." },
        { p: "Third-party brand names, trademarks, logos, and product references belong to their respective owners." }
      ]
    },
    {
      heading: "12. Use of the Website",
      blocks: [
        { p: "You agree not to:" },
        { list: ["Use the website for unlawful purposes", "Submit false or misleading information", "Attempt to gain unauthorised access to the website", "Introduce malware, viruses, or harmful code", "Interfere with website security or operation", "Copy or misuse website content", "Use automated tools to scrape or extract website content without permission", "Impersonate another person or organisation", "Use the website to infringe the rights of others"] },
        { p: "We reserve the right to restrict or terminate access to the website where misuse or violation of these Terms is suspected." }
      ]
    },
    {
      heading: "13. Website Enquiries and WhatsApp Communication",
      blocks: [
        { p: "The website may provide contact forms, quotation request forms, consultation forms, and WhatsApp communication links to help visitors contact Smart Levo India Pvt Ltd." },
        { p: "By submitting an enquiry or initiating communication through these channels, you agree to provide accurate information and understand that:" },
        { list: ["Submitting a form does not automatically create a contract.", "A quotation or proposal may be issued after reviewing your requirements.", "Final pricing, specifications, timelines, warranty, installation, and maintenance terms will be confirmed separately in writing.", "WhatsApp communication is subject to WhatsApp’s own terms and policies.", "We are not responsible for interruptions, delays, or technical issues caused by WhatsApp, internet service providers, or other third-party platforms.", "You should not submit confidential, unlawful, or unnecessary sensitive information through the website form or WhatsApp."] }
      ]
    },
    {
      heading: "14. Third-Party Services and Links",
      blocks: [
        { p: "The website may contain links to third-party websites, manufacturers, service providers, social media platforms, or other external resources." },
        { p: "We do not control and are not responsible for:" },
        { list: ["Third-party website content", "Availability of external services", "Accuracy of third-party information", "Privacy practices of external websites", "Products or services provided by third parties"] },
        { p: "Your use of third-party websites is subject to their own terms and policies." }
      ]
    },
    {
      heading: "15. Disclaimer",
      blocks: [
        { p: "We make reasonable efforts to keep the information on the website accurate and updated. However, we do not guarantee that:" },
        { list: ["All information will always be complete or error-free", "Product availability will remain unchanged", "Website content will always be current", "The website will be available without interruption", "The website will be free from technical errors or harmful components", "Every product or service will be suitable for every building or project"] },
        { p: "Final product suitability, specifications, pricing, and service scope will be determined through the relevant technical assessment and written agreement." }
      ]
    },
    {
      heading: "16. Limitation of Liability",
      blocks: [
        { p: "To the maximum extent permitted by applicable law, Smart Levo India will not be liable for indirect, incidental, special, consequential, or punitive losses arising from:" },
        { list: ["Use or inability to use the website", "Reliance on general website information", "Delays caused by third parties", "Product availability issues", "Manufacturer or supplier delays", "Site conditions", "Force majeure events", "Loss of business, revenue, profits, or opportunities"] },
        { p: "Where liability cannot legally be excluded, it will be limited to the extent permitted by applicable law and the terms of the relevant service agreement." }
      ]
    },
    {
      heading: "17. Force Majeure",
      blocks: [
        { p: "We will not be responsible for delays or failure to perform obligations caused by events beyond our reasonable control, including:" },
        { list: ["Natural disasters", "Fire", "Flood", "Epidemics or pandemics", "War", "Government restrictions", "Strikes", "Transportation disruptions", "Power failures", "Supplier or manufacturer delays", "Shortage of materials", "Technical or infrastructure failures"] },
        { p: "The affected party will make reasonable efforts to resume performance as soon as practicable." }
      ]
    },
    {
      heading: "18. Confidentiality",
      blocks: [
        { p: "We will take reasonable steps to protect confidential information shared by customers for the purpose of providing products or services." },
        { p: "Confidential information does not include information that:" },
        { list: ["Is publicly available", "Was already lawfully known", "Is independently developed", "Is received lawfully from another source", "Must be disclosed under applicable law"] }
      ]
    },
    {
      heading: "19. Changes to These Terms",
      blocks: [
        { p: "We may update these Terms & Conditions from time to time." },
        { p: "The updated version will be published on this page with a revised effective date. Continued use of the website after changes are published will constitute acceptance of the updated terms." }
      ]
    },
    {
      heading: "20. Governing Law and Jurisdiction",
      blocks: [
        { p: "These Terms & Conditions shall be governed by the laws of India." },
        { p: "Subject to applicable law, courts located in Mumbai, Maharashtra, India shall have jurisdiction over disputes arising from or relating to these Terms & Conditions." },
        { p: "Project-specific quotations, purchase orders, AMC agreements, and service contracts may contain additional terms that will apply to the relevant transaction." }
      ]
    },
    {
      heading: "21. Contact Us",
      blocks: [
        { p: "For questions regarding these Terms & Conditions, please contact us:" },
        { list: ["Company: Smart Levo India Pvt Ltd", "Website: smartlevo.com", "Email: info@smartlevo.com", "Phone: +91 9867 798 994 / +91 7700 971 812", "Address: 27, Ali Bilal Siddi CHSL, Alidada Estate, S.G. Barve Marg, Near Bus Depot, Kurla East, Mumbai, Maharashtra, India - 400024."] }
      ]
    }
  ]
};
